import { useEffect , useState , useRef } from "react";
import { useLocation } from "react-router-dom";

function Legal() {
    
    const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);
  
  const [showButton, setShowButton] = useState(false);
    const clickTimeoutRef = useRef(null);

    // Show/hide button on scroll
    useEffect(() => {
        const handleScroll = () => {
            setShowButton(window.scrollY > 500);
        };

        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Scroll to hash target on load
    useEffect(() => {
        const hash = window.location.hash;
        if (hash) {
            setTimeout(() => {
                const target = document.querySelector(hash);
                if (target) {
                    target.scrollIntoView({ behavior: 'smooth' });
                }
            }, 300);
        }
    }, []);

    // Click handler
    const handleClick = () => {
        if (clickTimeoutRef.current) {
            // Double click detected
            clearTimeout(clickTimeoutRef.current);
            clickTimeoutRef.current = null;
            window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
            // Wait to see if it's a double click
            clickTimeoutRef.current = setTimeout(() => {
                const target = document.querySelector('.other-privacy-content');
                if (target) {
                    target.scrollIntoView({ behavior: 'smooth' });
                }
                clickTimeoutRef.current = null;
            }, 300);
        }
    };


  return (
    <>
    <main className="container-fluid p-0">  
    <section className="legal-container">
            <div className="legal-wrapper">
                <div className="legal-content-section">
                    <h1 className="card-title-xl fw-l">Your Rights Matter</h1>
                    <p class="paragraph-md text-balance">
                        Federal and state laws are designed to ensure fair and respectful practices.
                        Understanding these protections helps you stay informed and confident every step of the way.
                    </p>
                </div>
                <div className="legal-image-container">
                    <img src="/assets/images/legalrights.webp" alt="" style={{aspectRatio:"18/8"}}/>
                </div>
            </div>
        </section> 
        
        <section className="privacy-section mb-3" id="">
            <div className="other-privacy-content">
                <div className="row">
                    <div className="col-md-12">
<div className="card " id=" ">
                            <h2 className="paragraph-xs text-balance">This is a communication from a debt collector. We are required under state law to notify consumers of the following rights. This list does not contain a complete list of the rights consumers have under state and federal law.</h2>
                        </div>
                        <div className="card " id="">
                        <h2 className="paragraph-xs"> California Residents : </h2>
                            <p className="xsmall mb-0">
                                California License number: 10735-99</p>
                        </div>
                        <div className="card " id="">
                        <h2 className="paragraph-xs"> Colorado Residents :</h2>
                            <p className="xsmall mb-1">Colorado office address: Colorado Manager, Inc. 8690 Wolff CT, STE 110, Westminster, CO 80031.
                                Phone number: (303) 920-4763. <br/>
                                Calling us or visiting our website will not preserve your rights set forth above to obtain verification of the debt
                                or the original creditor’s name and address, as such rights are only preserved by making a written request to us. A
                                consumer has the right to request in writing that a debt collector or collection agency cease further communication
                                with the consumer. A written request to cease communication will not prohibit the debt collector or collection
                                agency from taking any other action authorized by law to collect the debt.
                            </p>
                            <p className="xsmall mb-1">FOR INFORMATION ABOUT THE COLORADO FAIR DEBT COLLECTION PRACTICES ACT, SEE <a href="HTTPS://COAG.GOV/OFFICE-SECTIONS/CONSUMER-PROTECTION/CONSUMER-CREDIT-UNIT/COLLECTION-AGENCY-REGULATION/" target="_blank"> HTTPS://COAG.GOV/OFFICE-SECTIONS/CONSUMER-PROTECTION/CONSUMER-CREDIT-UNIT/COLLECTION-AGENCY-REGULATION/ </a></p>
                            <p className="xsmall">Colorado law prohibits credit bureaus from reporting medical debt or factoring medical debt into a credit score unless the consumer report is to be used in connection with a credit transaction that involves, or that may reasonably be expected to involve, a principal amount that exceeds the national conforming loan limit value for a one-unit property as determined by Federal Housing Finance Authority.</p>
                        </div>


                        <div className="card " id="">
                        <h2 className="paragraph-xs"> Connecticut Residents :</h2>
                            <p className="xsmall">Connecticut License Number: CCA-1134094</p>
                        </div>

                        <div className="card " id="">
                        <h2 className="paragraph-xs"> Maine Residents :</h2>
                            <p className="xsmall">If you have an issue about the way we are collecting your debt, contact the Maine Department of Professional and Financial Regulation, Bureau of Consumer Credit Protection at 35 State House Station, Augusta, ME 04333, 207-624-8527.</p>
                        </div>
                        
                        <div className="card " id="">
                        <h2 className="paragraph-xs"> Massachusetts Residents :</h2>
                            <p className="xsmall"><strong> NOTICE OF IMPORTANT RIGHTS:</strong> You have the right to make a written or oral request that telephone calls regarding your debt not be made to you at your place of employment. Any such oral request will be valid for only ten days unless you provide written confirmation of the request postmarked or delivered within seven days of such request. You may terminate this request by writing to the debt collector.</p>
                        </div>

                        <div className="card " id="">
                        <h2 className="paragraph-xs"> Minnesota Residents :</h2>
                            <p className="xsmall">If you feel that your concerns have not been addressed, please contact Credence Resource Management at  +1-855-880-4791and allow us the opportunity to try and address your concerns. Or you have the option to address any concerns with the Minnesota Attorney General’s Office which can be reached at 651-296-3353 or  +1-855-880-4791.</p>
                            <p className="xsmall">This collection agency is licensed by the Minnesota Department of Commerce.</p>
                        </div>

                        <div className="card " id="">
                        <h2 className="paragraph-xs"> Nevada Residents :</h2>
                            <p className="xsmall mb-1">Pursuant to Nevada Law, if you pay or agree to pay the debt or any portion of the debt, the payment or agreement to pay may be construed as (1) An acknowledgement of the debt by you; (2) A waiver by you of any applicable statute of limitations set forth in NRS 11.190 that otherwise precludes the collection of the debt. If you do not understand or have questions concerning your legal rights or obligation relating to this debt(s), you should seek legal advice.</p>
                            <p className="xsmall mb-1">Nevada License Number: CAD11478</p>
                            <p className="xsmall">Manager Certificate ID Number: CM11652</p>
                        </div>
                        
                        <div className="card" id="">
                        <h2 className="paragraph-xs"> New York Residents :</h2>
                            <p className="xsmall mb-1">Contact Leo Brown at Credence Resource Management at  +1-855-880-4791. This collection agency is also licensed by the city of Buffalo, license number CAG18-10043309.</p>
                            <p className="xsmall mb-1">We are required by regulation of the New York State Department of Financial Services to notify you of the following information. This information is NOT legal advice. Debt collectors, in accordance with the Fair Debt Collection Practices Act, 15 U.S.C. -º 1692 et seq., are prohibited from engaging in abusive, deceptive, and unfair debt collection efforts, including but not limited to:</p>
                            <ul className="xsmall ps-4 mb-0">
                                <li>The use or threat of violence;</li>
                                <li>Use of obscene or profane language;</li>
                                <li>Repeated phone calls made with the intent to annoy, abuse, or harass. <br/>
                                    If a creditor or debt collector receives a money judgment against you in court, state and federal laws may prevent the following types of income from being taken to pay the debt:
                                </li>
                                <li>Supplemental security income, (SSI);</li>
                                <li>Social security;</li>
                                <li>Public assistance (welfare);</li>
                                <li>Spousal support, maintenance (alimony) or child support;</li>
                                <li>Unemployment benefits;</li>
                                <li>Disability benefits;</li>
                                <li>Workers’ compensation benefits;</li>
                                <li>Public or private pensions;</li>
                                <li>Veterans’ benefits;</li>
                                <li>Federal student loans, federal student grants, and federal work study funds; and</li>
                                <li>Ninety percent of your wages or salary earned in the last sixty days.</li>
                            </ul>
                        </div>

                        <div className="card " id="">
                        <h2 className="paragraph-xs">New York City Residents :</h2>
                            <p className="xsmall">This collection agency is licensed by the New York City Department of Consumer Affairs, license numbers 2067278-DCA and 2067275-DCA; Credence Resource Management, LLC. Please contact us to confirm your preferred language for future communications. All communications are in English with the following exception: Spanish-speaking agents are available by phone. Written communications may be available in Spanish upon request. A translation and description of commonly-used debt collection terms is available in multiple languages at <a href="http://www.nyc.gov/dcwp" target="_blank"> www.nyc.gov/dcwp.</a></p>
                        </div>

                        <div className="card " id="">
                        <h2 className="paragraph-xs"> North Carolina Residents :</h2>
                            <p className="xsmall mb-1">This collection agency is licensed by the North Carolina Department of Insurance, Permit Numbers: 119507139 and 119507140.</p>
                            <p className="xsmall ">This is an attempt to collect a debt. Any information obtained will be used for that purpose. This is a communication from a debt collector.</p>
                        </div>
                        
                        <div className="card " id="">
                        <h2 className="paragraph-xs"> Rhode Island Residents :</h2>
                            <p className="xsmall ">The State of Rhode Island general laws prohibits credit bureaus from reporting medical debt or factoring medical debt into a credit score.</p>
                        </div>
                        
                        <div className="card " id="">
                        <h2 className="paragraph-xs"> Tennessee Residents :</h2>
                            <p className="xsmall ">This collection agency is licensed by the Tennessee Collection Service Board of the Department of Commerce and Insurance.</p>
                        </div>

                    </div>
                </div>
                
             </div>        
        </section>
    </main>
    
    <button
            id="scrollToTopBtn"
            className="scrollTopButton"
            aria-label="Scroll to top"
            style={{ display: showButton ? 'block' : 'none' }}
            onClick={handleClick}
        >
            <i className="bx bx-chevron-up"></i>
        </button>
    </>
  );
}

export default Legal;
